/** Human-readable label for history operation type (e.g. create_room → "Room Created") */
export function formatOperationTypeLabel(opType) {
  if (opType == null || opType === '') return '—';
  const map = {
    create_room: 'Room Created',
    upload_image: 'Upload image',
    generate_mask: 'Detect objects',
    photorealistic: 'Generate photorealistic',
  };
  if (map[opType]) return map[opType];
  return opType.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}
